import React, { useState } from "react";
import { useInstantSearch } from "react-instantsearch";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdownMenu";
import { Button } from "@/components/ui/button";
import Icon from "@/components/icons";
import { useProductCreatedRange } from "@/components/Search/components/SearchContextProvider";
import getDefaultDateRange from "@/components/Search/utils/getDefaultDateRange";
import useFormEvents from "@/hooks/eventing/useFormtEvents";
import { buildRecentlyAddedFieldEvent } from "@/components/Search/utils/buildRecentlyAddedFieldEvent";

function RecentlyAddedDropdown() {
  const { status } = useInstantSearch();
  const [open, setOpen] = useState(false);
  const {
    productCreatedRange,
    setProductCreatedRange,
    clearProductCreatedRange,
  } = useProductCreatedRange();
  const defaultRange = getDefaultDateRange();
  const filterLabel = defaultRange.filterLabel;
  const filterOptionLabel = defaultRange.filterOptionLabel;
  const { fieldSelected } = useFormEvents({});

  if (status !== "idle") {
    return null;
  }

  const isSelected = productCreatedRange !== null;

  const handleToggle = () => {
    if (typeof window !== "undefined") {
      const formEvent = buildRecentlyAddedFieldEvent(
        "search-filters",
        filterLabel,
        filterOptionLabel,
        isSelected,
      );
      fieldSelected(formEvent);
    }
    if (isSelected) {
      clearProductCreatedRange();
    } else {
      setProductCreatedRange(defaultRange);
    }
  };

  return (
    <DropdownMenu modal={false} open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          id="filter-recently-added-trigger"
          variant="primaryOutline"
          className={`font-normal border-2 whitespace-nowrap py-2.5 px-6 h-11 flex items-center gap-1 ${isSelected ? "border-[3px] font-semibold" : ""}`}
        >
          <span className="p-0 m-0 text-md hover:text-white">
            {filterLabel}
          </span>
          <Icon type="keyboard-arrow-down-material" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="mx-2 w-[280px] max-h-[400px] overflow-y-auto scrollbar-thin gap-3 p-0 z-50"
      >
        <div className="px-4 py-2">
          <DropdownMenuItem
            onSelect={(e) => {
              e.preventDefault();
              handleToggle();
            }}
            className="cursor-pointer"
          >
            <div className="flex justify-start items-center py-[10px]">
              <input
                type="checkbox"
                checked={isSelected}
                readOnly
                id="filter-recently-added-yes"
                className="border-2 mr-2 border-gray-700 min-w-4 h-5 w-5 cursor-pointer"
              />
              <label
                htmlFor="filter-recently-added-yes"
                className="text-gray-700 flex items-center mb-0 leading-5 text-sm cursor-pointer"
              >
                {filterOptionLabel}
              </label>
            </div>
          </DropdownMenuItem>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default RecentlyAddedDropdown;
